import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const originalTermMonthsFilterLabel = () => t({
    message: 'Original term months',
    comment: 'Insights: Original term months filter',
});
export function OriginalTermMonthsFilter() {
    return <NumberRangeFilter name="metadataDocumentOriginalTermMonths" label={originalTermMonthsFilterLabel()}/>;
}
